import script from "./ProjectComp.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectComp.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectComp.vue?vue&type=style&index=0&id=42fb6f59&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42fb6f59"]])

export default __exports__